var map = {
	"./a-topazio.webp": "2b97",
	"./colchoes.webp": "093a",
	"./comodas-e-penteadeiras.webp": "af3c",
	"./cozinhas.webp": "8fce",
	"./escrivaninhas.webp": "7b9e",
	"./estofados.webp": "67f8",
	"./fale-conosco.webp": "4bad",
	"./nossa-historia.webp": "786e",
	"./onde-comprar.webp": "3050",
	"./representantes.webp": "6da1",
	"./roupeiros.webp": "6240",
	"./ser-um-afiliado.webp": "26e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e172";